import AlertComponent from '../../components/alert'
import { mergeOptions } from '../../assets/js/plugin_helper'

let $vm

const plugin = {
  install (Vue) {
    if (!$vm) {
      const Alert = Vue.extend(AlertComponent)
      $vm = new Alert({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const alert = {
      show (options = {}) {
        if (typeof options === 'object') {
          mergeOptions($vm, options)
          if (options.content) {
            $vm.$el.querySelector('.ssui-dialog__bd').innerHTML = options['content']
          }
        } else if (typeof options === 'string') {
          $vm.$el.querySelector('.ssui-dialog__bd').innerHTML = options
        }
        this.watcher && this.watcher()
        this.watcher = $vm.$watch('showValue', (val) => {
          val && options.onShow && options.onShow($vm)
          if (val === false && options.onHide) {
            options.onHide($vm)
            this.watcher && this.watcher()
          }
        })
        $vm.$off('on-sure')
        $vm.$on('on-sure', () => {
          options && options.onSure && options.onSure()
        })
        $vm.showValue = true
      },
      hide () {
        $vm.showValue = false
        this.watcher && this.watcher()
        this.watcher = null
      }
    }

    if (!Vue.$ssvue) {
      Vue.$ssvue = {
        alert
      }
    } else {
      Vue.$ssvue.alert = alert
    }

    Vue.mixin({
      created: function () {
        this.$ssvue = Vue.$ssvue
      }
    })
  }
}

export default plugin
export const install = plugin.install




// WEBPACK FOOTER //
// ./node_modules/@finance/ssvue/src/plugins/alert/index.js